import { render, staticRenderFns } from "./registerBonusModal.vue?vue&type=template&id=b1b1d640"
import script from "./registerBonusModal.vue?vue&type=script&lang=js"
export * from "./registerBonusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports